import { UnicodeEntity } from '@mews/enums';
import { LocalizedDateFromUtc, Parenthesized, SpacedDash } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useGetServiceNamesByIdQuery } from '../../queries/useGetServiceNamesByIdQuery';

interface LinkedReservationsCellProps {
    customerId: string;
    reservationId?: string;
}

export const LinkedReservationsLabel = ({ customerId, reservationId }: LinkedReservationsCellProps) => {
    const { data: reservationData } = useRepositorySuspenseQuery('reservations', 'getAll', {
        accountIds: [customerId],
    });
    const { data: services } = useGetServiceNamesByIdQuery();
    const reservation = reservationData.reservations?.find(({ id }) => id === reservationId);

    if (reservation == null) return null;

    const serviceName = services[reservation.serviceId];

    return (
        <Stack>
            {serviceName}
            {UnicodeEntity.NoBreakSpace}
            {reservation.number}
            {UnicodeEntity.NoBreakSpace}
            <Parenthesized>
                <LocalizedDateFromUtc utcString={reservation.startUtc} />
                {SpacedDash}
                <LocalizedDateFromUtc utcString={reservation.endUtc} />
            </Parenthesized>
        </Stack>
    );
};
